import { render, staticRenderFns } from "./TimeBlock.vue?vue&type=template&id=dd1daed0&scoped=true&"
import script from "./TimeBlock.vue?vue&type=script&lang=js&"
export * from "./TimeBlock.vue?vue&type=script&lang=js&"
import style0 from "./TimeBlock.vue?vue&type=style&index=0&id=dd1daed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1daed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd1daed0')) {
      api.createRecord('dd1daed0', component.options)
    } else {
      api.reload('dd1daed0', component.options)
    }
    module.hot.accept("./TimeBlock.vue?vue&type=template&id=dd1daed0&scoped=true&", function () {
      api.rerender('dd1daed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/TimeBlock.vue"
export default component.exports